import { Component, ViewChild, Input, Output, EventEmitter,  OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PagePreloaderComponent } from '../../shared/ui';
import { Product, InventoryLocation, Report, ReportDetail } from '../shared';
import { ReportLossService } from './report-loss.service';

@Component({
  selector: 'report-loss',
  styles: [require('./report-loss.component.scss')],
  template: require('./report-loss.component.pug')
})
export class ReportLossComponent implements OnInit {
     @ViewChild(PagePreloaderComponent) preloader;

     @Input() product: Product;
     @Input() location: InventoryLocation;
     @Output() applyReportSucess = new EventEmitter();

    fg: FormGroup = new FormGroup({});
    reportErrorMessage: string = 'Error';
    reportError: boolean = false;
    successMessage: string = 'Success';
    reportSuccess: boolean = false;

    reasons: Array<any> = [
                             { id: 1, title: 'Damaged' },
                             { id: 2, title: 'Lost' },
                             { id: 3, title: 'Missing' },
                             { id: 4, title: 'Tester' },
                             { id: 5, title: 'Other' }
                         ];

    constructor(private _reportLossService: ReportLossService) {}

    ngOnInit() {
        this.preloader.hide();
    }


    reportLoss(e: MouseEvent) {

      e.preventDefault();
      this.reportError = false;
      this.reportSuccess = false;

      let controls = this.fg.controls;

      if (this.fg.valid) {

          this.preloader.show();

          let qty = controls['quantity'].value;
          let reason = this._getReason(+controls['reason'].value);
          let comments = controls['comments'].value;
          let report = new Report(
                                    this.product.id,
                                    this.location.id,
                                    new ReportDetail(qty, reason, comments)
                                  );

          this._reportLossService.reportLoss(report)
              .subscribe(
                  res => {

                       this.preloader.hide();
                       this.applyReportSucess.emit();
                       this.reportSuccess = true;

                  },
                  err => {

                      this.preloader.hide();
                      this.reportError = true;
                  }
             );
      } else {
          this.reportError = true;
      }
  }

  private _getReason(reasonId: number) {
       let reason = this.reasons.find(r => r.id === reasonId);
       return reason.title;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/report-loss/report-loss.component.ts